<template>
<el-form ref="form" label-width="120px">
    <el-row :xs="24" sm="12">
        <el-col :xs="24" :sm="20">
            <el-form-item :label="msg('店铺名称：')">
                <el-input v-model.trim="shopName" placeholder="请输入店铺名称"></el-input>
            </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="20">
            <el-form-item :label="msg('统一编号：')">
                <el-input v-model.trim="shopId" placeholder="请输入统一编号"></el-input>
            </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="20">
            <el-form-item :label="msg('Token：')">
                <el-input v-model.trim="token" placeholder="请输入token"></el-input>
            </el-form-item>
        </el-col>
    </el-row>
    
    <div style="text-align:center;margin-top: 15px;">
        <el-button type="primary" size="mini"  @click="onSubmit"><i class="el-icon-check"></i><span>{{msg('确定')}}</span></el-button>
        <el-button  size="mini" v-on:click="$emit('close-dg')">{{msg('取消')}}</el-button>
    </div>

</el-form> 
</template>

<script>
export default {
  name: 'ShopBindMomo',
  data(){
    return{
        id: null,
        shopName:null,
        shopId:null,
        token:null,
    }
  }, 
  computed:{
  },
  props:{
  },
  mounted: function(){
  },
  methods:{
    init(shop){
        this.id = null;
        this.shopName = null;
        this.shopId = null;
        this.token = null;
        if(shop){
            this.id = shop.id || null;
            this.shopName = shop.actualName || shop.name || null;
            this.shopId = shop.shopId || null;
            this.token = shop.accessToken || null;
        }
    },
    onSubmit(){
        if(!this.token || !this.shopId || !this.shopName){
            this.$message(this.msg('请输入店铺信息'));
            return;
        }
        let param = {
            id: this.id,
            name:this.shopName,
            shopId:this.shopId,
            accessToken:this.token,
        }
        let url = this.id ? this.$kit.api.shop.updateMomo : this.$kit.api.shop.bindMomo;
        this.$axios.post(url,param)
            .then((result) => {
                    if(result.status){
                        this.$emit("close-dg", true);
                    }
                    this.$message(result.msg);
                });
    },
  }
}
</script>


<style scoped lang="scss">
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 64px;
        height: 64px;
        line-height: 64px;
        text-align: center;
    }
    .avatar {
        width: 64px;
        height: 64px;
        display: block;
    }

.w-e-toolbar{flex-wrap: wrap;}
.icon-list{ margin:0px; padding:0px; display:flex; flex-wrap:wrap;  border: 1px solid #eaeefb;}
.icon-list li{cursor:pointer;
    padding:8px; border-right: 1px solid #eee;
    border-bottom: 1px solid #eee;
    display:flex; flex-direction: column; justify-content: center; align-items:center;
}
.icon-list li i{font-size:18px;} 
.icon-list li:hover{color:#5CB6FF;}
.upload-icon .el-form-item__content{display:flex;}
.upload-icon .el-form-item__content >*:last-child{margin-left:10px;}
</style>
